import Vue from 'vue'

function imageG(data) {
  data = "https://www.commnowmatrix.com/" + data;
  return data
}

// 数字转换中文
function ConversionNum(n) {
  if (!/(^[1-9]\d*$)/) {
    return '非法数字';
  }
  var uppercase = '千百亿千百十万千百十个';
  var nLength = n.length;
  var newStr = '';
  if (uppercase.length - nLength < 0) {
    return '数字过长';
  }
  uppercase = uppercase.substr(uppercase.length - nLength);
  for (var i = 0; i < nLength; i++) {
    newStr += '零一二三四五六七八九'.charAt(n[i]) + uppercase.charAt(i);
  };
  newStr = newStr.substr(0, newStr.length - 1);
  return newStr;
}

// 单独转换直播
function changeOneLive(data) {
  if (data.imageUrl) {
    data.imageUrl = "https://www.commnowmatrix.com/" + data.imageUrl;
  }
  if (data.lecturerImage) {
    data.lecturerImage =
      "https://www.commnowmatrix.com/" + data.lecturerImage;
  }
  // data.startTime = formDate(data.startTime);
  return data
}

function requestIsMember(that) {
  Vue.prototype.$axios
    .get("/newapi/business-service-contact/ccs/ccs-contact/view-by-openid", {
      params: {
        openId: localStorage.getItem('openid')
      }
    })
    .then(res => {
      console.log(res.data, '查看是否会员');
      if (res.data.code == '00000') {
        if (res.data.data.isMember) {
          Vue.prototype.isMember = true
          localStorage.setItem('userinfo', JSON.stringify(res.data.data))
          // if(!localStorage.getItem('userinfo')){
          InformationTime(that)
          // }

        } else {
          Vue.prototype.isMember = false
        }

      }
    });
}

function creatDialog(that, userform) {
  let updateInformationTime = JSON.parse(localStorage.getItem('updateInformationTime'))
  let HTMLperson = ""
  HTMLperson = `  <div class="updateInformationTime_box_head" style="text-align:left;width:85%;margin: 0 auto;">尊敬的用户，感谢您关注西门子数字化工业软件，为了后续更好的为您提供服务和帮助，麻烦确认以下您的个人信息是否需要修改？</div>
                        <div class="updateInformationTime_box" style="display: flex;flex-wrap:wrap;text-align:left;width:85%;margin: 0 auto;">
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">姓名</span>
                            <span>${userform.name}</span>
                        </p>  
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">称呼</span>
                            <span>${userform.sex===1?'男':'女'}</span>
                        </p> 
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">城市</span>
                            <span>${userform.province}${userform.city}</span>
                        </p>
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">公司</span>
                            <span>${userform.company}</span>
                        </p>    
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">部门</span>
                            <span>${userform.department}</span>
                        </p>
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">行业</span>
                            <span>${userform.industry}</span>
                        </p> 
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">邮件</span>
                            <span style="width: 64%;">${userform.email}</span>
                        </p> 
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">手机</span>
                            <span>${userform.phone}</span>
                        </p>  
                        <p style="display: flex;width: 100%;">
                            <span style="display: block;width: 36%;">身份</span>
                            <span>${userform.customFields.identity}</span>
                        </p>      
                    </div>`
  let newTime = new Date()
  let isThreeMouth = (newTime.getTime() - updateInformationTime) > 7776000000
  if (!updateInformationTime || isThreeMouth) {
    let flags = localStorage.getItem('flag')
    that.$dialog.confirm({
        title: '个人信息',
        message: HTMLperson,
        allowHtml: true,
        confirmButtonText: "确认无误",
        confirmButtonColor: "#323233",
        cancelButtonText: "修改信息",
        className: "message_updateInformationTime"
      })
      .then(() => {
        // on confirm
        // let updateInformationTime
        let newDate = new Date()
        newDate = JSON.stringify(newDate.getTime())
        console.log(newDate)
        localStorage.setItem('updateInformationTime', newDate)
      })
      .catch(() => {
        // on cancel
        that.$router.push({
          path: "/user-regist",
          query: {
            text: "true"
          }
        });
      });


  }
}

function InformationTime(that) {
  let userform = ""
  let timer = setInterval(() => {
    userform = JSON.parse(localStorage.getItem('userinfo'))
    try {
      userform.customFields = JSON.parse(userform.customFields)
    } catch (err) {
      userform.customFields = userform.customFields;
    }
    console.log(userform, '123');
    // userform.customFields=JSON.parse(userform.customFields)
    console.log(userform, 123123);
    let flags = localStorage.getItem('flag')
    if (userform) {
      //    if(!flags){
      creatDialog(that, userform)
      clearInterval(timer)
      //    }         

    }
  }, 1);

}

function addClass(el, className) {
  if (hasClass(el, className)) {
    return
  }
  if (el.className === '') {
    el.className += className
  } else {
    let newClass = el.className.split(' ')
    newClass.push(className)
    el.className = newClass.join(' ')
  }

}

function hasClass(el, className) {
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)')
  return reg.test(el.className)
}

function removeClass(el, className) {
  if (hasClass(el, className)) {
    el.className = el.className.replace(new RegExp('(\\s|^)' + className + '(\\s|$)'), '');
  };
}


function formatDate(now) {
  now = new Date(now);
  var year = now.getFullYear(); //取得4位数的年份
  var month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
  var date = now.getDate(); //返回日期月份中的天数（1到31）
  var hour = now.getHours(); //返回日期中的小时数（0到23）
  var minute = now.getMinutes(); //返回日期中的分钟数（0到59）
  var second = now.getSeconds(); //返回日期中的秒数（0到59）
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}

function animation_scroll(dom, length, time) {
  const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
  let spacingInex = time / spacingTime; // 计算循环的次数
  let nowTop = dom.scrollLeft; // 获取当前滚动条位置
  let everTop = length / spacingInex; // 计算每次滑动的距离
  let scroll_i = 0;
  let scrollTimer = setInterval(() => {
    if (spacingInex > 0) {
      scroll_i++;
      spacingInex--;
      dom.scrollLeft = nowTop + everTop * scroll_i;
    } else {
      clearInterval(scrollTimer); // 清除计时器
    }
  }, spacingTime);
}

function getImgResizeParam(obj, fineTune) {
  let ft = (fineTune && _.isInteger(fineTune)) ? fineTune : 0;
  let width = ',w_' + (obj.w + ft);
  let height = ',h_' + (obj.h + ft);
  return '?x-oss-process=image/resize,' + width + height + '/format,jpg';
}

// 埋点
// function Buried_point(Buried_point_message) {
//     // 渠道id
//     Buried_point_message.channelId = 64;
//     // 联系人id
//     Buried_point_message.contactId = localStorage.getItem('userid');
//     // 机构id
//     Buried_point_message.insId = 50;
//     // 来源类型
//     Buried_point_message.sourceType = 1;
//     let contentTagIds = [];
//     if (Buried_point_message.contentTagIds) {
//         // console.log(Buried_point_message.contentTagIds)
//         Buried_point_message.contentTagIds.forEach((item, index) => {
//             contentTagIds.push(item.id)
//         })
//     }
//     Buried_point_message.contentTagIds = contentTagIds.join(',')
//     // console.log(contentTagIds,contentTagIds.join(','))
//     Vue.prototype.$axios({
//         method: "post",
//         url: "/newapi/business-service-kafka/kafka/send",
//         data: {
//             "data": JSON.stringify(Buried_point_message),
//             "topic": "ActionRecord"
//         }
//     })
//         .then(res => {
//             console.log(res, '埋点数据');

//         });
// }


export default {
  requestIsMember,
  imageG,
  addClass,
  removeClass,
  changeOneLive,
  ConversionNum,
  formatDate,
  animation_scroll,
  getImgResizeParam,
  InformationTime
}



// WEBPACK FOOTER //
// ./src/assets/js/Commonmethods.js